module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "toast-section"
  }, [_c('div', {
    staticClass: "toast",
    class: [_vm.visible ? 'fade-in' : 'fade-out']
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84750f22","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/toast/Toast.vue
// module id = 252
// module chunks = 1